import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { tooltipTitleText } from "./styles.module.scss";

const CustomTooltip = ({ metrics, title, style }) => {
  return (
    <div style={style}>
      <div className={classNames(tooltipTitleText)}>{title}</div>
      {metrics.map(({ name, value, color }, index) => (
        <div key={index} className="d-flex align-items-center">
          {color && (
            <div
              style={{
                backgroundColor: color,
                width: "1em",
                height: "1em",
                minWidth: "1em",
                margin: "0 1em"
              }}
              data-selector="shape"
            />
          )}
          {name}: {value}
        </div>
      ))}
    </div>
  );
};

export const metricProps = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    color: PropTypes.string
  })
);

CustomTooltip.propTypes = {
  /** title of the tooltip */
  title: PropTypes.string.isRequired,
  /** array of metrics in text form to be displayed in hover tooltip */
  metrics: metricProps.isRequired,
  /** style to apply to the container */
  style: PropTypes.object
};

export default CustomTooltip;
